<template>
  <el-header height="auto">
      <div class="hdr-tit">
        <h5 class="primary-color">{{ dashboardTitle }}</h5> <h6 v-if="userData">{{userData.ENTITY_NAME}}</h6>
      </div>
      <el-menu class="el-menu-demo" mode="horizontal">
        <el-menu-item v-if="$store.getters['uicomponents/isEmployees'] && $store.getters['employees/userTypeName']&&eventid[checkedittype]!==undefined||checkedittype=='0'">
            <router-link v-if="$store.getters['employees/userTypeName']!='technician'" class="add-btn" tag="button" :to="{ path:'/employees/'+$store.getters['employees/userTypeName']+'/add'}">Add {{$store.getters['employees/userTypeName'] | capitalize}}</router-link>
             <router-link v-else class="add-btn" tag="button" :to="{ path:'/employees/'+$store.getters['employees/userTypeName']+'/add'}">Add Lab technician</router-link>
          </el-menu-item>
         <!--  <el-menu-item class="left" v-if="$store.getters['uicomponents/isAccounts']">
            <router-link class="add-btn" tag="button" :to="{ path: '/accounts/add-bill'}">Add Bill</router-link>
          </el-menu-item> -->
        
         <!--  <el-menu-item v-if="$store.getters['masters/setemp']&&$store.getters['uicomponents/isMaster']&&$store.getters.masterTypeName&&$store.getters.actionType">
            <router-link class="add-btn" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/'+$store.getters['masters/geturl']}" >
                                    {{$store.getters['masters/setemp'].employee?$store.getters['masters/setemp'].employee==4?'Add Test':$store.getters['masters/setemp'].employee==3?' Add Tasks':'Add Treatment':$store.getters['masters/geturl']}}
                               </router-link>
          </el-menu-item>
          <el-menu-item v-if="$store.getters['uicomponents/isMaster'] && $store.getters.masterTypeName =='servietype_task' &&$store.getters['masters/setemp']&&$store.getters['masters/setemp'].employee==4">
            <router-link class="add-btn2" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/addPackage'}">Add a new Package</router-link>
          </el-menu-item> -->
          <el-menu-item v-if="$store.getters['uicomponents/isService']&&eventid[checkserviceeditype]!==undefined">
             <router-link class="add-btn2" tag="button" :to="{ path: '/services/'+$store.getters.serviceTypeName+'/add'}">Add {{$store.getters.serviceTypeName=='tasks'?'Task':$store.getters.serviceTypeName=='treatments'?'Treatment':$store.getters.serviceTypeName=='treatment'?'Treatment':$store.getters.serviceTypeName=='tests'?'Test':'Packages'}}</router-link>
           <!--  <router-link class="add-btn2" tag="button" :to="{ path: '/services/'+$store.getters.serviceTypeName+'/add'}">Add Price</router-link> -->
          </el-menu-item> 
         <!--  <el-menu-item v-if="$store.getters['uicomponents/isMaster']&&$store.getters.masterTypeName!='department'&&eventid[checkmasteredittype]!==undefined&&$store.getters.masterTypeName=='packages'">
            <router-link class="add-btn2" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/add'}">Add {{$store.getters.masterTypeName=='tasks'?'Task':$store.getters.masterTypeName=='treatments'?'Treatment':$store.getters.masterTypeName=='treatment'?'Treatment':$store.getters.masterTypeName=='tests'?'Test':'Packages'}}</router-link>
          </el-menu-item>  -->
            <el-menu-item>
              <el-select v-if="cHospitals && cHospitals.length && functionId && functionId['122']" v-model="value" placeholder="Child Hospitals" @change="getChildToken" size="small">
                <el-option
                v-for="item in cHospitals"
                :key="item.eid"
                :label="item.ename"
                :value="item.eid">
                </el-option>
              </el-select>
                </el-menu-item>
        <el-submenu index="4">
          <template slot="title"><img :src="userProfile" class="avtar"></template>
          <el-menu-item index="2-1" @click="toProfile()">Profile</el-menu-item>
          <el-menu-item index="2-1" @click="changpassword()">Change Password</el-menu-item>
          <el-menu-item index="2-1" @click.native="logout()">Logout</el-menu-item>
        </el-submenu>
      </el-menu>
  </el-header>
</template>
<script>
// import { mapState } from 'vuex'
import UI_RULES from "../../util/ui-rules.js";
import API from '../../services/api.js';
import { hms_url } from '../../../config/endpoints.js'
export default {
  // computed: mapState(['dashboardTitle']),
  name: "HeaderStrip",
  data() {
    return {
      userData: null,
       checkedittype:null,
       checkmasteredittype:null,
       checkserviceeditype:null,
       cHospitals: [],
       value: ''
    }
  },
  mounted() {
    this.gettypes();
    this.getmastertypes();
    this.getservicetypes();
    if(this.$store.getters['auth/getLoginStatus']&&_.isEmpty(this.$store.getters['employees/userData'])){
      this.userData = JSON.parse(localStorage.getItem("userData"));
      this.$store.dispatch('employees/SET_USER_DATA', this.userData);
    } else {
      this.userData = this.$store.getters['employees/userData'];
    }
    if(localStorage.getItem('cname')) {
      this.value = localStorage.getItem('cname')
    }
    this.getChildHospitals()
    },
  methods: {
    getChildHospitals () {
      let self = this
      API.getChildHospitals(function(response) {
        if(response && response.data && response.data.length) {
          self.cHospitals = response.data
        }
      });
    },
    getChildToken (eid) {
      let self = this
      self.$store.dispatch('dashboard/SET_DASHLOADER', true)
      localStorage.setItem('cname', eid)
      let aid = localStorage.getItem('access_id')
      let parentEid = localStorage.getItem('entityId')
      let req = {
        parentEid: parentEid,
        childEid: eid,
        accessId: aid
      }
      this.$store.dispatch("auth/CHILD_AUTH", req).then(res => {
        let userTypeId = res.userdata.USER_TYPE_ID;
        localStorage.setItem("utid", userTypeId);
        this.$store.dispatch("employees/SET_USER_DATA", res.userdata);
        this.$store.dispatch("employees/SET_USER_TYPE", userTypeId);
        window.location.replace(hms_url + 'dashboard')
      })
    },
    logout: function() {
      this.$store.dispatch("auth/LOGOUT").then(() => {
        this.$router.push("/login");
      });
    },
    changpassword: function() {
      this.$router.push("/change-password");
    },
     gettypes:function(){
      let _self = this,
     gettype=UI_RULES.getUserType(_self.$store, _self.$route.params);
    switch(gettype){
       case "0" : _self.checkedittype="1110";break;
       case "1" : _self.checkedittype="1112";break;
       case "2" : _self.checkedittype="1114";break;
        case "3" : _self.checkedittype="1116";break;
        case "4" : _self.checkedittype="1118";break;
        default:_self.checkedittype="0";break;
    }
    },
    getmastertypes: function() {
      let _self = this,
        gettype = UI_RULES.getMasterType(_self.$store, _self.$route.params);
      switch (gettype) {
        case 1:
         
          _self.checkmasteredittype = "1164";
          break;
        case 2:
          _self.checkmasteredittype = "1162";
          break;
        case 3:
          _self.checkmasteredittype = "1166";
          break;
          case 4:
          _self.checkmasteredittype = "1168";
          break;
      }
    },
     getservicetypes: function() {
      let _self = this,
        gettype = UI_RULES.getServiceType(_self.$store, _self.$route.params);
      switch (gettype) {
        case 0:
          _self.checkserviceeditype = "1170";
          break;
        case 1:
          _self.checkserviceeditype = "1172";
          break;
        case 2:
          _self.checkserviceeditype = "1174";
          break;
          case 3:
          _self.checkserviceeditype = "1176";
          break;
      }
    },
    toProfile() {
      let emp = "";
      if(this.userData) {
        let userId = this.userData.USER_ID;
        if(this.userData.USER_TYPE_ID) {
          switch (this.userData.USER_TYPE_ID) {
            case "0":
              emp = "user";
              break;
            case "1":
              emp = "doctor";
              break;
            case "2":
              emp = "physiotherapist";
              break;
            case "3":
              emp = "nurse";
              break;
            case "4":
              emp = "technician";
              break;
            default:
              emp = "";
              break;
          }
          this.$router.push(`/myprofile/view`);
        }
      } else {
        this.$router.go();
      }
      
    }
  },

  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    dashboardTitle() {
      return this.$store.getters["getDashboardTitle"];
    },
     eventid() {
      this.eventsData= JSON.parse(localStorage.getItem("eventids"));
       return this.eventsData
    },
    userProfile() {
      return this.userData&&this.userData.IMAGE ? this.userData.IMAGE : "/static/images/user.svg";
    },
    functionId() {
      let fid = JSON.parse(localStorage.getItem('fnids'))
      return fid
    }
  },
  watch: {
    $route(to, from) {
      this.gettypes();
      this.getmastertypes();
      this.getservicetypes();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/HeaderStrip.vue